<div class="row no-gutters ad-lightbox" style="max-width: 750px;
    background-color:{{bg_color}}; border-radius: 15px 15px; overflow: hidden;">
    <div class="col-md-{{image_space}} col-sm-12">
        <img [routerLink]="link" src="{{image}}">
    </div>
    <div class="col-md-{{12-image_space}} col-sm-12">
        <div class="container p-5 ">

            <div>
                <h1 [routerLink]="link" class="title"> {{title}}</h1>

            </div>
            <div>
                <div class="subtitle"> {{subheading}} </div>
            </div>

            <div>
                <label class="starting-from" i18n> Starting from </label>
                <div class="price-tag">{{this.registry.current_currency}} {{this.final_price | number : this.registry.getSettingByID('price_format') }}</div>
            </div>
            <div style="margin-top: 20px;" class="text-right">
                <a class="btn btn-primary" [routerLink]="link"  i18n> ORDER NOW <i class="fa fa-arrow-circle-o-right"></i></a>
            </div>

        </div>

    </div>

</div>
